"use client";
import Link from "next/link";
import { ReactNode } from "react";

export const SkipToContentLink = ({
  children = "Hopp til hovedinnhold",
  id = "hovedinnhold",
}: {
  children?: ReactNode;
  id?: string;
}) => {
  return (
    <div className="fixed top-0 left-0 bg-black text-white">
      <Link href={`#${id}`} className="sr-only focus:not-sr-only">
        {children}
      </Link>
    </div>
  );
};
